/**
 * @generated SignedSource<<29340f2e6d497d87a3536eccce2d16ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleContentVariant_user" | "HpSharedFeaturedModuleContent_user">;
  readonly " $fragmentType": "HpSharedFeaturedModule_user";
};
export type HpSharedFeaturedModule_user$key = {
  readonly " $data"?: HpSharedFeaturedModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isHpSaleModuleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModule_user",
  "selections": [
    {
      "condition": "isHpSaleModuleVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModuleContent_user"
        }
      ]
    },
    {
      "condition": "isHpSaleModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModuleContentVariant_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1ace1b2048a0d19692a344281d95062e";

export default node;
